// extracted by mini-css-extract-plugin
var _1 = "ProfileInfoWidget-modulecontent__03kg6 WidgetContentContainer-moduleWidgetContentContainer__HxIkI";
export { _1 as "content" }
